import { IUpdateMetaObraChecklistServicoUseCase } from "../../../presentation/useCases/update/update_meta_obra_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateMetaObraChecklistServicoUseCase
 */

export class UpdateMetaObraChecklistServicoUseCase implements IUpdateMetaObraChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateMetaObraChecklistServico(
    idObraChecklistServico: number,
    meta: number,
  ): Promise<void> {
    await this.repository.updateMetaObraChecklistServico(
      idObraChecklistServico, meta);
  }
}
